<template>
  <div id="appCapsule">
    <!-- <h1>Random User</h1> -->
    <div class="section" :class="{ 'mt-3 mb-3': index !== 0, 'mt-0 mb-3': index == 0 }" v-for="(cargo, index) in cargos"
      :key="index.id">
      <CardView :cargo="cargo" />
    </div>
    <p class="alert alert-warning text-center">لطفا منتظر بمانید...</p>
  </div>
</template>
<script>
import axios from "axios";
// import delivery_methods from "@/delivery_methods";
import CardView from "./cargo/components/CardView";

export default {
  name: "load",
  components: {
    CardView,
  },
  data() {
    return {
      cargos: [],
      idUser: window.localStorage.getItem("idUser"),
      page: 0,
      fetchingData: false,
      axiosConfig: {
        headers: {
          'Authorization': `Bearer ${window.localStorage.getItem("token")}`,
          'Accept': 'application/json'
        }
      }
    };
  },
  methods: {
    getInitialCargos() {
      axios
        .get(`https://core.iran-tarabar.ir/api/driver/getNewLoadForDriver/0`, this.axiosConfig)
        .then((response) => {
          // console.log(response);
          this.cargos = response.data.loads;
          // console.log(this.cargos);
        }).catch(function (res) {
          // handle error
          // console.log(res);

        });
    },
    getNextCargo() {
      window.onscroll = () => {
        let bottomOfWindow =
          document.documentElement.scrollTop + window.innerHeight ===
          document.documentElement.offsetHeight;
        if (bottomOfWindow) {
          this.fetchingData = true
          // console.log(this.cargos[this.cargos.length - 1].id);
          axios.get(`https://core.iran-tarabar.ir/api/driver/getNewLoadForDriver/${this.cargos[this.cargos.length - 1].id}`, this.axiosConfig)
            .then((res) => {
              this.fetchingData = false
              // console.log(...res.data.loads);
              this.cargos.push(...res.data.loads);
            });
        }
      };
    },
  },
  beforeMount() {
    this.getInitialCargos();
  },
  mounted() {
    this.getNextCargo();
  },
};
</script>
<style>
.user {
  display: flex;
  background: #ccc;
  border-radius: 1em;
  margin: 1em auto;
}

.user-avatar {
  padding: 1em;
}

.user-avatar img {
  display: block;
  width: 100%;
  min-width: 64px;
  height: auto;
  border-radius: 50%;
}

.user-details {
  padding: 1em;
}

.user-name {
  margin: 0;
  padding: 0;
  font-size: 2rem;
  font-weight: 900;
}
</style>